import moment from 'moment-timezone';
import React, { ChangeEvent, Fragment,  useContext, useEffect, useState } from 'react';
import {  BaseButton, Button,  DefaultButton, Dialog, DialogFooter, DialogType, DirectionalHint, Dropdown, DropdownMenuItemType, Icon, IDropdownOption, Label,  PrimaryButton, Slider, TextField, TooltipHost } from 'office-ui-fabric-react';
import FileSaver from 'file-saver';
import { WsSalesSolutionAction, WsSalesSolutionAssumption, WsSalesSolutionDependency, WsSalesSolutionItem, WsSalesSolutionMetric } from '../../../core';
import { WsSalesSolutionDeliverableClass, WsSalesSolutionWorkProductClass, WsSalesSolutionOfferingRoleClass, WsSalesSolutionToolClass, WsSalesSolutionRiskClass, documentFormats, getSalesCapabilityRolesFromConfig } from '../../../core-sales';
import { apiPost } from '../../../helpers-sales';
import { getChildItems, getChildItemsFromTopLevelItems, itemIsCapability } from '../../../helpers/item-helpers';
import { getItemPath } from '../../../core/sales-actions';
import { Loading } from '../../Shared';
import { getConfigValue, newAssumption, newDependency } from './helpers';
import { WsSalesSolutionContext, WsSalesSolutionSaveOptions } from '../SalesSolutionContext';
import { getComplexity } from './SolutionSteps';
import { getPersonRoleDaysArray, getPersonRoles, getTimelineRoles,  WsPersonRole } from '../../../helpers/timeline-helpers';
import { BiInfoCircle } from "react-icons/bi";



type WsSalesSolutionCoreMetricsListProps = {
  title: string;
  items: WsSalesSolutionItem[];
  setItems: React.Dispatch<React.SetStateAction<WsSalesSolutionItem[]>>;
  avanade: boolean;
};

const WsSalesSolutionCoreMetricsList = (props: WsSalesSolutionCoreMetricsListProps) => {

  const solutionContext = useContext(WsSalesSolutionContext);

  const x = getChildItemsFromTopLevelItems(
    props.items, 'metrics', {
      includeChildCapabilities: true,
      includeChildActions: true,
      filterSelectedCapabilities: true,
      filterSelectedActions: true
    }
  ) as [ WsSalesSolutionMetric, WsSalesSolutionItem | WsSalesSolutionAction, string][];

  const list = x.filter((y) => y[0] && y[0].core);

  const itemList = list.map((li) => {

    const listItem = li[0];

    const metricEffort = listItem.effort;
    const metricValue  = listItem.value;

    return (
      <tr key={`ws-sales-item-list-${listItem.id}`}>
        <td style={{ fontSize: '13px', verticalAlign: 'middle', paddingTop: '12px' }}>{listItem.name}</td>
        { props.avanade && <td style={{ fontSize: '13px', verticalAlign: 'middle', paddingTop: '12px' }}>{metricEffort}</td> }
        <td>
          <TextField
            onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined): void => {
              const newItems = [ ...props.items ];
              if (newValue) {
                const newValueInt = Number(newValue);
                if (!isNaN(newValueInt)) {
                  listItem.value = newValueInt;
                }
              } else {
                listItem.value = 0;
              }
              props.setItems(newItems);

              setTimeout(async () => {
                await solutionContext.createOrSave(solutionContext.currentStep, { showSuccess: true });
              }, 1000);
            }}
            value={ metricValue ? `${metricValue}` : '' }
          />
        </td>
        <td style={{ fontSize: '13px', verticalAlign: 'middle' }}>
          {li[1].name}
        </td>
        <td style={{ fontSize: '13px', verticalAlign: 'middle' }}>
          {li[2].slice(1).replace(/\//g, ' / ')}
        </td>
      </tr>
    );
  });

  return (
    <div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
      <table className="ws-sales-core-metric-list table is-fullwidth is-hoverable">
        <thead>
          <tr>
            <th>Metric</th>
            { props.avanade && <th>Effort</th> }
            <th style={{ width: 100 }}>Quantity</th>
            <th>Action</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {itemList}
        </tbody>
      </table>
    </div>
  );
};





type WsSalesSolutionRoleTypesListProps = {
  title: string;
  avanade: boolean;
  items: WsSalesSolutionItem[];
  setItems: React.Dispatch<React.SetStateAction<WsSalesSolutionItem[]>>;
};

const WsSalesSolutionRoleTypesList = (props: WsSalesSolutionRoleTypesListProps) => {

  let list: any[] = getChildItemsFromTopLevelItems(props.items, 'roles', { includeChildCapabilities: true, includeChildActions: true, filterSelectedCapabilities: true, filterSelectedActions: true });

  const itemList = list.map((listItemAndActionItem) => {

    const listItem = listItemAndActionItem[0];
    const actionItem = listItemAndActionItem[1];

    return (
      <tr key={`ws-sales-item-list-${listItem.id}`}>
        <td>{listItem.name}</td>
        <td>{listItem.value}%</td>
      </tr>
    );
  });

  return (
    <div style={{ width: 400, marginLeft: 'auto', marginRight: 'auto' }}>
      <table className="table is-fullwidth is-hoverable">
        <thead>
          <tr>
            <th>Role</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {itemList}
        </tbody>
      </table>
    </div>
  );
};




type WsSalesSolutionComplexityProps = {
  title: string;
  setComplexityDialogVisible: React.Dispatch<React.SetStateAction<boolean>>;
  salesProcess: any;
  setSalesProcess: React.Dispatch<any>;
  currentStep: number;
  createOrSave: (step: number, options?: WsSalesSolutionSaveOptions) => Promise<void>;
};

const WsSalesSolutionComplexity = (props: WsSalesSolutionComplexityProps) => {

  const [ complexity, setComplexity ] = useState<any>(getComplexity(props.salesProcess));

  const onDismiss = (ev?: React.MouseEvent<HTMLButtonElement, MouseEvent> | undefined) => {
    props.setComplexityDialogVisible(false);
  };

  const onClickCancel = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {
    props.setComplexityDialogVisible(false);
  };

  const onClickSave = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {
    props.setComplexityDialogVisible(false);

    const salesProcess = { ...props.salesProcess };

    salesProcess.fields['complexity'] = complexity;

    props.setSalesProcess({ ...salesProcess });

    setTimeout(() => {
      props.createOrSave(props.currentStep, { showSuccess: true });
    }, 1000);
  };

  return (
    <Dialog
      className="ws-dialog-select ws-sales-solution-link-dialog"
      hidden={false}
      onDismiss={onDismiss}
      dialogContentProps={{
        type: DialogType.normal,
        title: props.title
      }}
      modalProps={{
        isBlocking: false,
        styles: {
          // main: { width: 300 }
        }
      }}
    >
      <Fragment>
        <div className="ws-sales-solution-complexity-form">

          <div className="columns">
            <div className="column">

              <Slider
                label={'Solution Complexity'}
                min={0.5}
                max={5}
                step={0.5}
                defaultValue={1}
                value={complexity}
                showValue={true}
                valueFormat={(value: number) => {
                  return value.toFixed(1);
                }}
                snapToStep
                onChanged={(event: MouseEvent | TouchEvent | KeyboardEvent, value: number) => {
                  setComplexity(value);
                }}
              />

              <br />

            </div>
          </div>

        </div>
      </Fragment>
      <DialogFooter>
        <>
          <DefaultButton onClick={onClickCancel} text="Cancel" />
          <PrimaryButton onClick={onClickSave}   text="Save" style={{ marginLeft: '4px' }} />
        </>
      </DialogFooter>
    </Dialog>
  );
};


type WsSalesSolutionLinksProps = {
  items: WsSalesSolutionItem[];
  setItems: React.Dispatch<React.SetStateAction<WsSalesSolutionItem[]>>;
  title: string;
  setShowLinksDialog: React.Dispatch<React.SetStateAction<boolean>>;
  salesProcess: any;
  setSalesProcess: React.Dispatch<any>;
  currentStep: number;
  createOrSave: (step: number, options?: WsSalesSolutionSaveOptions) => Promise<void>;
};

const WsSalesSolutionLinks = ({ items, setItems, salesProcess, setSalesProcess, title, setShowLinksDialog, currentStep, createOrSave }: WsSalesSolutionLinksProps) => {

  const onDismiss = (ev?: React.MouseEvent<HTMLButtonElement, MouseEvent> | undefined) => {
    setShowLinksDialog(false);
  };

  const onClickCancel = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {
    setShowLinksDialog(false);
  };

  const onClickSave = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {
    setShowLinksDialog(false);
    createOrSave(currentStep, { showSuccess: true });
  };

  return (
    <Dialog
      className="ws-dialog-select ws-sales-solution-link-dialog"
      hidden={false}
      onDismiss={onDismiss}
      dialogContentProps={{
        type: DialogType.normal,
        title
      }}
      modalProps={{
        isBlocking: false,
        styles: {
          // main: { width: 300 }
        }
      }}
    >
      <Fragment>
        <div className="ws-sales-solution-link-form">

          <div className="columns">
            <div className="column">
              <TextField
                label="AEP"
                placeholder="Link to AEP"
                value={salesProcess.fields?.aepUrl ? salesProcess.fields?.aepUrl : '' }
                onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined) => {
                  if (newValue && salesProcess.fields) {
                    salesProcess.fields.aepUrl = newValue;
                  } else {
                    salesProcess.fields.aepUrl = '';
                  }
                  setSalesProcess({ ...salesProcess });
                }}
              />

              <br />

              <TextField
                label="C365"
                placeholder="Link to C365"
                value={salesProcess.fields?.c365Url ? salesProcess.fields?.c365Url : '' }
                onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined) => {
                  if (newValue && salesProcess.fields) {
                    salesProcess.fields.c365Url = newValue;
                  } else {
                    salesProcess.fields.c365Url = '';
                  }
                  setSalesProcess({ ...salesProcess });
                }}
              />

              <br />
            </div>
          </div>

        </div>
      </Fragment>
      <DialogFooter>
        <>
          <DefaultButton onClick={onClickCancel} text="Cancel" />
          <PrimaryButton onClick={onClickSave}   text="Save" style={{ marginLeft: '4px' }} />
        </>
      </DialogFooter>
    </Dialog>
  );
};


const uploadDocument = async (documentType: string, file: File | undefined) => {

  if (file) {

    const formData = new FormData();

    formData.append('documentType', documentType);

    formData.append('documentFileName', file.name);

    formData.append(
      'documentFile',
      file,
      file.name
    );

    const uploadResult = await apiPost('/sales/documents/upload', formData);

    if (uploadResult && uploadResult.documentId) {
      console.log('upload success!');

      return uploadResult;

    } else {
      return undefined;
    }

  } else {
    return undefined;
  }
};


const getDocumentDownload = async (documentId: string) => {

  const documentDownloadResult = await apiPost(`/sales/documents/download/${documentId}`, {});

  if (documentDownloadResult && documentDownloadResult.sasUrl) {
    return documentDownloadResult;

  } else {
    return undefined;
  }
};


const fieldsValid = (fields: { [ key: string ]: any }) => {
  let valid = true;

  const keys = Object.keys(fields).filter((key) => key !== 'comments');

  if (keys.length > 0) {

    keys.forEach((key: string) => {
      console.log(`6 : ${key}`);

      const value = fields[key];

      if (value) {

        if (typeof value === 'object') {

          if (value.id === '') {
            console.log('3');
            valid = false;
          }
        }

      } else {
        console.log('2');
        valid = false;
      }
    });

  } else {
    console.log('1');
    valid = false;
  }

  return valid;
};




const fieldsDefaultValues: { [ key: string ]: { [ key: string ]: any } } = {
  Dependencies:    {
    name: ''
  },
  Assumptions:     {
    name: ''
  },
  Deliverables:    {
    name: '',
    description: '',
    format:      '',
    file:        undefined
  },
  'Work Products': {
    name:        '',
    description: '',
    format:      '',
    file:        undefined
  },
  Roles:           {
    name: ''
  },
  Tools:           {
    name: ''
  },
  Risks:           {
    name:        '',
    consequence: '',
    mitigation:  '',
    impact:      '',
    probability: '',
    comments:    ''
  }
};



const getFields = (title: string, editItem: any | undefined, editItemId: string): { [ key: string ]: any } => {

  const defaultValues = { ...fieldsDefaultValues[title] };

  if (editItem && editItemId !== '') {

    const f: { [ key: string ]: { [ key: string ]: any } } = {};

    Object.keys(defaultValues).forEach((key: string) => {

      if (Object.hasOwn(editItem, key)) { // typeof editItem[key] !== 'undefined'
        f[key] = editItem[key];
      }
    });

    return f;

  } else {
    return defaultValues;
  }
};



const dialogTitles: { [ key: string ]: string } = {
  Dependencies:    'Dependency',
  Assumptions:     'Assumption',
  Deliverables:    'Deliverable',
  'Work Products': 'Work Product',
  Roles:           'Role',
  Tools:           'Tool',
  Risks:           'Risk'
};

type WsSalesSolutionAddDialogProps = {
  title: string;
  editItem: any | undefined;         // TODO: add types
  setEditItem: (value: any) => void; // TODO: add types
  editItemId: string;                // TODO: remove
  setEditItemId: React.Dispatch<React.SetStateAction<string | undefined>>; // TODO: remove
  items: WsSalesSolutionItem[];
  setItems: React.Dispatch<React.SetStateAction<WsSalesSolutionItem[]>>;
  offeringAction: WsSalesSolutionItem | WsSalesSolutionAction;
};

const WsSalesSolutionAddDialog = (props: WsSalesSolutionAddDialogProps) => {

  const { editItem, setEditItem, editItemId, setEditItemId, items, setItems, offeringAction } = props;

  const itemType = dialogTitles[props.title];


  console.log('=== editItem ===');
  console.log(editItem);


  const [ fields, setFields ] = useState<{ [ key: string ]: any }>(getFields(props.title, editItem, editItemId));

  const [ file, setFile ] = useState<File>();

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {

      // set file
      setFile(e.target.files[0]);
      // TODO: remove file and use fields only

      // set fields
      fields['file'] = e.target.files[0];
      setFields({ ...fields });
    }
  };



  const onDismiss = (ev?: React.MouseEvent<HTMLButtonElement, MouseEvent> | undefined) => {
    setEditItem(undefined);
    setEditItemId(undefined);
  };

  const onClickCancel = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {
    setEditItem(undefined);
    setEditItemId(undefined);
  };

  const onClickSave = async (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {

    const nextItems = [ ...items ];

    if (itemType === 'Dependency') {

      const x = newDependency(fields['name']);
      if (offeringAction.dependencies) {
        offeringAction.dependencies.push(x);
      } else {
        offeringAction.dependencies = [ x ];
      }

    } else if (itemType === 'Assumption') {

      const x = newAssumption(fields['name']);
      if (offeringAction.assumptions) {
        offeringAction.assumptions.push(x);
      } else {
        offeringAction.assumptions = [ x ];
      }

    } else if (itemType === 'Deliverable') {

      const x = editItem ? editItem : new WsSalesSolutionDeliverableClass(fields['name']);
      x.name        = fields['name'];
      x.description = fields['description'];
      x.format      = fields['format'];

      const uploadDocumentResult = await uploadDocument('101', file);

      if (uploadDocumentResult) {
        x.documentId = `${uploadDocumentResult.documentId}`;
      }

      if (editItem) {
      } else {
        if (offeringAction.children) {
          offeringAction.children.push(x);
        } else {
          offeringAction.children = [ x ];
        }
      }

    } else if (itemType === 'Work Product') {

      const x = editItem ? editItem : new WsSalesSolutionWorkProductClass(fields['name']);
      x.name        = fields['name'];
      x.description = fields['description'];
      x.format      = fields['format'];

      const uploadDocumentResult = await uploadDocument('102', file);

      if (uploadDocumentResult) {
        x.documentId = `${uploadDocumentResult.documentId}`;
      }

      if (editItem) {
      } else {
        if (offeringAction.children) {
          offeringAction.children.push(x);
        } else {
          offeringAction.children = [ x ];
        }
      }

    } else if (itemType === 'Tool') {

      const x = new WsSalesSolutionToolClass(fields['name']);
      if (offeringAction.children) {
        offeringAction.children.push(x);
      } else {
        offeringAction.children = [ x ];
      }

    } else if (itemType === 'Risk') {

      const x = new WsSalesSolutionRiskClass(fields['name']);

      x.consequence = fields['consequence'] || '';
      x.mitigation  = fields['mitigation']  || '';
      x.impact      = fields['impact']      || '';
      x.probability = fields['probability'] || '';
      x.comments    = fields['comments']    || '';

      if (offeringAction.children) {
        offeringAction.children.push(x);
      } else {
        offeringAction.children = [ x ];
      }

    }

    setEditItem(undefined);
    setEditItemId(undefined);

    setItems(nextItems);
  };



  return (
    <Dialog
      className="ws-dialog-select ws-sales-solution-link-dialog"
      hidden={false}
      onDismiss={onDismiss}
      dialogContentProps={{
        type: DialogType.normal,
        title: editItemId ? `Edit ${itemType}` : `Add ${itemType}`
      }}
      modalProps={{
        isBlocking: false,
        styles: {
          // main: { width: 300 }
        }
      }}
    >
      <Fragment>
        <div className="ws-sales-solution-link-form">

          <div className="columns">
            <div className="column">

              <TextField
                label="Name"
                placeholder="Name"
                value={ fields['name'] || '' }
                onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined) => {
                  if (newValue) {
                    fields['name'] = newValue;
                  } else {
                    fields['name'] = '';
                  }
                  setFields({ ...fields });
                }}
              />

              <br />

              {
                (
                  itemType === 'Deliverable' ||
                  itemType === 'Work Product'
                )
                &&
                <>
                  <TextField
                    label="Description"
                    placeholder="Description"
                    value={ fields['description'] || '' }
                    onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined) => {
                      if (newValue) {
                        fields['description'] = newValue;
                      } else {
                        fields['description'] = '';
                      }
                      setFields({ ...fields });
                    }}
                  />

                  <br />

                  <Dropdown
                    label="Format"
                    placeholder="Select Format"
                    options={documentFormats.map((documentFormat) => {
                      return { key: documentFormat.id, text: documentFormat.name };
                    })}
                    onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined): void => {
                      if (option) {
                        fields['format'] = {
                          id: option.key,
                          name: option.text
                        }
                      }
                      setFields({ ...fields });
                    }}
                    selectedKey={ fields['format'] ? fields['format'].id : undefined }
                  />

                  <br />

                  <div>
                    <Label>Document</Label>
                    <input type="file" onChange={handleFileChange} />
                    {/* {file && `${file.name} (${file.size})`} */}
                  </div>
                </>
              }

              {
                itemType === 'Risk'
                &&
                <>
                  <TextField
                    label="Consequence"
                    placeholder="Consequence"
                    value={ fields['consequence'] || '' }
                    onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined) => {
                      if (newValue) {
                        fields['consequence'] = newValue;
                      } else {
                        fields['consequence'] = '';
                      }
                      setFields({ ...fields });
                    }}
                  />
                  <br />
                  <TextField
                    label="Mitigation"
                    placeholder="Mitigation"
                    value={ fields['mitigation'] || '' }
                    onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined) => {
                      if (newValue) {
                        fields['mitigation'] = newValue;
                      } else {
                        fields['mitigation'] = '';
                      }
                      setFields({ ...fields });
                    }}
                  />
                  <br />
                  <TextField
                    label="Impact"
                    placeholder="Impact"
                    value={ fields['impact'] || '' }
                    onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined) => {
                      if (newValue) {
                        fields['impact'] = newValue;
                      } else {
                        fields['impact'] = '';
                      }
                      setFields({ ...fields });
                    }}
                  />
                  <br />
                  <TextField
                    label="Probability"
                    placeholder="Probability"
                    value={ fields['probability'] || '' }
                    onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined) => {
                      if (newValue) {
                        fields['probability'] = newValue;
                      } else {
                        fields['probability'] = '';
                      }
                      setFields({ ...fields });
                    }}
                  />
                  <br />
                  <TextField
                    label="Comments"
                    placeholder="Comments"
                    value={ fields['comments'] || '' }
                    onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined) => {
                      if (newValue) {
                        fields['comments'] = newValue;
                      } else {
                        fields['comments'] = '';
                      }
                      setFields({ ...fields });
                    }}
                  />
                  <br />
                </>
              }
            </div>
          </div>

        </div>
      </Fragment>
      <DialogFooter>
        <>
          <DefaultButton onClick={onClickCancel} text="Cancel" />
          <PrimaryButton onClick={onClickSave}   text={editItem ? 'Save' : 'Add'} style={{ marginLeft: '4px' }} disabled={ !fieldsValid(fields) } />
        </>
      </DialogFooter>
    </Dialog>
  );
};


const getAddNewItemLabel = (title: string) => {

  if (title === 'Dependencies') {
    return 'Add Dependency';

  } else if (title === 'Assumptions') {
    return 'Add Assumption';

  } else if (title === 'Deliverables') {
    return 'Add Deliverable';

  } else if (title === 'Work Products') {
    return 'Add Work Product';

  } else if (title === 'Roles') {
    return 'Add Role';

  } else {
    return undefined;
  }
};




const getRoleOptions = (salesOfferingRoles: WsSalesSolutionOfferingRoleClass[], team: string, location: string): IDropdownOption[] => {
  const options: IDropdownOption[] = [];

  salesOfferingRoles
    .filter((role: WsSalesSolutionOfferingRoleClass) => role.team === team && role.location === location)
    .forEach((role) => {
      options.push({ key: role.id, text: role.name });
    });

  return options;
};




const getRoleSelectedKey = (role: WsSalesSolutionOfferingRoleClass, staticRoles: WsSalesSolutionOfferingRoleClass[]) => {

  // TODO: remove this function when not needed

  const roleFind = staticRoles.find((r) => r.id === role.staticId);

  if (roleFind) {

    return roleFind.id; // staticId

  } else {

    const roleStatic = staticRoles.find((r) => r.id === role.id);

    if (roleStatic) {
      console.warn('wrong role id and staticId');

      // role.id = ulid(); // fix wrong id by creating new from ulid

      // role.staticId = roleStatic.id; // fix wrong static id by setting is from static role

      return roleStatic.id; // staticId

    } else {
      return undefined;
    }
  }
};



const WsPersonRoleDetails = (props: { personRole: WsPersonRole, staticRoles: WsSalesSolutionOfferingRoleClass[] }) => {

  const staticRole = props.staticRoles.find((r) => r.id === props.personRole.staticId);

  const days = getPersonRoleDaysArray(props.personRole.days);

  // console.log(days);

  const daysList = getPersonRoleDaysArray(props.personRole.days).map((dayEffort, index) => {
    const effort = dayEffort.effort.toFixed();
    return (
      <span key={`ws-person-role-day-${index}`} style={{ display: 'block' }}>
        <b>{dayEffort.day}:</b> {effort}
      </span>
    );
  });

  if (staticRole) {

    return (
      <>
        <TooltipHost
          content={daysList}
          id={`ws-item-role-details-tooltip-${props.personRole.id}`}
          className="ws-item-role-details-tooltip"
          calloutProps={{
            className: 'ws-item-role-details-tooltip-callout'
          }}
        >
          <BiInfoCircle
            aria-describedby={`ws-item-role-details-tooltip-${props.personRole.id}`}
            style={{
              fontSize: '16px',
              verticalAlign: 'middle',
              marginLeft: '3px',
              marginTop: '-3px'
            }}
          />
        </TooltipHost>
      </>
    );

  } else {
    return null;
  }
};


const getItemTypeByTitle = (title: string) => {
  if (title === 'Assumptions') {
    return 'assumptions';
  } else if (title === 'Dependencies') {
    return 'dependencies';
  } else if (title === 'Deliverables') {
    return 'deliverables';
  } else if (title === 'Work Products') {
    return 'workProducts';
  } else if (title === 'Roles') {
    return 'roles';
  } else if (title === 'Tools') {
    return 'tools';
  } else if (title === 'Risks') {
    return 'risks';
  } else {
    return 'actions';
  }
};


type WsSalesSolutionDependenciesAndAssumptionsProps = {
  title: string;
  mode: string;
  items: WsSalesSolutionItem[];
  setItems: React.Dispatch<React.SetStateAction<WsSalesSolutionItem[]>>;
  offeringAction: WsSalesSolutionItem | WsSalesSolutionAction;
  avanade: boolean;
};

const WsSalesSolutionDependenciesAndAssumptions = ({ title, mode, items, setItems, offeringAction, avanade }: WsSalesSolutionDependenciesAndAssumptionsProps) => {

  const [ roles, setRoles ] = useState<WsSalesSolutionOfferingRoleClass[] | undefined>(undefined);

  useEffect(() => {

    if (title === 'Roles') {

      setTimeout(async () => {

        const salesCapabilityRoles = await getConfigValue('roles', 'admin');

        if (salesCapabilityRoles && salesCapabilityRoles.roles) {
          setRoles(getSalesCapabilityRolesFromConfig(salesCapabilityRoles.roles));
        }

      }, 250);
    }

  }, []);



  const [ editItem,   setEditItem   ] = useState<any    | undefined>(undefined);
  const [ editItemId, setEditItemId ] = useState<string | undefined>(undefined);


  const [ showUnique, setShowUnique ] = useState<boolean>(true);



  // let list: [ WsSalesItemChild, WsSalesSolutionItem | WsSalesSolutionAction, string ][] = [];

  let list: any[] | undefined = [];



  if (mode === 'read') {

    if (title === 'Assumptions') {
      list = getChildItems(offeringAction, 'assumptions', { includeChildCapabilities: true, includeChildActions: true, filterSelectedCapabilities: true, filterSelectedActions: true });

    } else if (title === 'Dependencies') {
      list = getChildItems(offeringAction, 'dependencies', { includeChildCapabilities: true, includeChildActions: true, filterSelectedCapabilities: true, filterSelectedActions: true });

    } else if (title === 'Deliverables') {
      list = getChildItems(offeringAction, 'deliverables', { includeChildCapabilities: true, includeChildActions: true, filterSelectedCapabilities: true, filterSelectedActions: true });

    } else if (title === 'Work Products') {
      list = getChildItems(offeringAction, 'workProducts', { includeChildCapabilities: true, includeChildActions: true, filterSelectedCapabilities: true, filterSelectedActions: true });

    } else if (title === 'Roles') {
      // list = getChildItems(offeringAction, 'roles',        { includeChildCapabilities: true, includeChildActions: true, filterSelectedCapabilities: true, filterSelectedActions: true });

      // if (showUnique) {
      //   list = getUniqueRoles(list);
      // }

      // console.clear();

      const timelineRoles = getTimelineRoles(offeringAction, moment.tz('2024-04-01', 'UTC').toDate(), { includeChildCapabilities: true, items });

      const personRoles = getPersonRoles(timelineRoles);

      list = personRoles.map((personRole) => {

        let listItem: [ WsPersonRole, WsSalesSolutionItem | WsSalesSolutionAction, string,  ] = [
          personRole,
          offeringAction,
          ''
        ];

        return listItem;
      });

      // list = personRoles.map((personRole) => {
      //   console.log('========================================');
      //   console.log(`${personRole.name}`);
      //   Object.keys(personRole.days).forEach((key) => {
      //     const effort = personRole.days[key];
      //     console.log(`${key} : ${effort.effort.toFixed(2)}${isWorkDay(key) ? '' : ' weekend'}`);
      //   });

      //   let listItem: [ WsSalesItemChild, WsSalesSolutionItem | WsSalesSolutionAction, string,  ] = [
      //     new WsSalesSolutionOfferingRoleClass({ name: personRole.name }),
      //     offeringAction,
      //     ''
      //   ];

      //   const role = roles?.find((r) => r.id === personRole.staticId);

      //   if (role) {
      //     listItem = [
      //       role,
      //       offeringAction,
      //       ''
      //     ];
      //   }

      //   return listItem;

      // }).filter((r) => r[0].name);



    } else if (title === 'Tools') {
      list = getChildItems(offeringAction, 'tools',        { includeChildCapabilities: true, includeChildActions: true, filterSelectedCapabilities: true, filterSelectedActions: true });

    } else if (title === 'Risks') {
      list = getChildItems(offeringAction, 'risks',        { includeChildCapabilities: true, includeChildActions: true, filterSelectedCapabilities: true, filterSelectedActions: true });
    }
  }

  if (mode === 'edit') {

    if (title === 'Dependencies') {
      list = offeringAction.dependencies;

    } else if (title === 'Assumptions') {
      list = offeringAction.assumptions;

    } else if (title === 'Deliverables') {
      list = offeringAction.children?.filter((child) => child instanceof WsSalesSolutionDeliverableClass);

    } else if (title === 'Work Products') {
      list = offeringAction.children?.filter((child) => child instanceof WsSalesSolutionWorkProductClass);

    } else if (title === 'Roles') {

      if (offeringAction.children) {
        const l: [ WsSalesSolutionOfferingRoleClass, number ][] = [];

        offeringAction.children.forEach((child, index: number) => {
          if (child instanceof WsSalesSolutionOfferingRoleClass) {
            l.push([ child, index ]);
          }
        });

        list = l;
      }

    } else if (title === 'Tools') {
      list = offeringAction.children?.filter((child) => child instanceof WsSalesSolutionToolClass);

    } else if (title === 'Risks') {
      list = offeringAction.children?.filter((child) => child instanceof WsSalesSolutionRiskClass);
    }

    list = list
      ?
      list.map((i, index: number) => {
        if (Array.isArray(i)) {
          return [ i[0], undefined, i[1] ]; // only for roles
        } else {
          return [ i, undefined, index ];
        }
      })
      :
      [];
  }

  const style = mode !== 'edit' && title === 'Roles' ? { display: 'inline-block' } : {};

  if ((title === 'Roles' && roles) || (title !== 'Roles')) {

    return (
      <div className="ws-sales-solution-admin-metrics-list ws-sales-solution-item-children-list" style={style}>
        <h6 className="title is-6" style={{ marginBottom: '10px' }}>{title}</h6>


        {/* {
          mode !== 'edit'
          &&
          title === 'Roles'
          &&
          <div style={{ position: 'absolute', top: '-1px', left: '50px', minWidth: '200px' }}>
            <Checkbox
              checked={showUnique}
              onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined, checked?: boolean | undefined): void => {
                if (showUnique) {
                  setShowUnique(false);
                } else {
                  setShowUnique(true);
                }
              }}
              label="Only Show Unique"
            />
          </div>
        } */}


        {/* list */}

        {
          list && Array.isArray(list) && list.length > 0
          ?
          list.map((listItemAndActionItem, index: number) => {

            if (listItemAndActionItem && listItemAndActionItem[0]) {

              const listItem   = listItemAndActionItem[0];
              const listAction = listItemAndActionItem[1];
              const listIndex  = listItemAndActionItem[2];

              const key = `ws-sales-solution-metric-${index}-${listItem.id}-${listItem.staticId}`;

              return (
                <div key={key} data-key={key} className="ws-class ws-sales-solution-admin-metrics-item">
                  {
                    mode === 'edit'

                    ?

                    // edit

                    <>

                      {
                        (title === 'Roles' && roles)
                        ?
                        <>
                          <div className="ws-sales-solution-admin-metrics-item-field" style={{ flexGrow: 1 }}>
                            <Dropdown

                              options={[

                                { key: 'AVANADE_ONSHORE_UK', text: 'Avanade UK', itemType: DropdownMenuItemType.Header },

                                ...getRoleOptions(roles, 'AVANADE', 'ONSHORE_UK'),

                                { key: 'divider_1', text: '-', itemType: DropdownMenuItemType.Divider },
                                { key: 'AVANADE_OFFSHORE_UK', text: 'Avanade Offshore', itemType: DropdownMenuItemType.Header },

                                ...getRoleOptions(roles, 'AVANADE', 'OFFSHORE_INDIA'),


                                { key: 'divider_1', text: '-', itemType: DropdownMenuItemType.Divider },
                                { key: 'ACCENTURE_ONSHORE_UK', text: 'Accenture UK', itemType: DropdownMenuItemType.Header },

                                ...getRoleOptions(roles, 'ACCENTURE', 'ONSHORE_UK'),

                                { key: 'divider_1', text: '-', itemType: DropdownMenuItemType.Divider },
                                { key: 'ACCENTURE_OFFSHORE_UK', text: 'Accenture Offshore', itemType: DropdownMenuItemType.Header },

                                ...getRoleOptions(roles, 'ACCENTURE', 'OFFSHORE_INDIA'),

                              ]}

                              onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined): void => {
                                const newItems = [ ...items ];

                                if (option) {

                                  if (offeringAction.children) {

                                    // remove
                                    offeringAction.children = offeringAction.children.filter((x, xindex: number) => {
                                      return !(x instanceof WsSalesSolutionOfferingRoleClass && x.id === listItem.id && listIndex === xindex);
                                    });

                                    // add
                                    const x = roles.find((role) => role.id === option.key);
                                    if (x) {
                                      const xClone = x.clone();
                                      offeringAction.children.splice(listIndex, 0, xClone);
                                    }
                                  }
                                }

                                setItems(newItems);
                              }}

                              placeholder="Select Role"
                              selectedKey={getRoleSelectedKey(listItem, roles)}
                            />
                          </div>
                          <div className="ws-sales-solution-admin-metrics-item-field" style={{ width: '45px', marginTop: '1px' }}>
                            <TextField
                              onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined): void => {
                                const newItems = [ ...items ];
                                if (newValue) {
                                  const newValueInt = parseInt(newValue, 10);
                                  if (!isNaN(newValueInt)) {
                                    listItem.value = newValueInt;
                                  }
                                } else {
                                  listItem.value = 0;
                                }
                                setItems(newItems);
                              }}
                              value={ listItem.value ? `${listItem.value}` : '' }
                            />
                          </div>
                          <div className="ws-sales-solution-admin-metrics-item-field" style={{ width: '17px', marginTop: '7px', marginLeft: '-3px' }}>%</div>
                        </>
                        :
                        <>
                          {
                            (title === 'Deliverables' || title === 'Work Products')
                            ?
                            <>
                              <div className="ws-sales-solution-admin-metrics-item-field" style={{ flexGrow: 1, paddingTop: 5 }}>{listItem.name} ({listItem.format.name})</div>
                              <div className="ws-sales-solution-admin-metrics-item-field" style={{ width: '20px' }}>
                                <Icon className="ws-sales-solution-metric-delete" iconName={'PageEdit'} style={{ fontSize: '17px' }}
                                  onClick={() => {
                                    setEditItem(listItem);
                                    setEditItemId(listItem.id);
                                  }}
                                />
                              </div>
                            </>
                            :
                            <div className="ws-sales-solution-admin-metrics-item-field" style={{ flexGrow: 1 }}>
                              <TextField
                                onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined): void => {
                                  const newItems = [ ...items ];

                                  if (newValue) {
                                    listItem.name = newValue;
                                  } else {
                                    listItem.name = '';
                                  }

                                  setItems(newItems);
                                }}
                                value={ listItem.name }
                              />
                            </div>
                          }
                        </>
                      }

                      {/* delete */}

                      <div className="ws-sales-solution-admin-metrics-item-field" style={{ width: '20px' }}>
                        <Icon className="ws-sales-solution-metric-delete" iconName={'Delete'} style={{ fontSize: '17px' }} onClick={
                          () => {

                            const nextItems = [ ...items ];

                            if (title === 'Dependencies') {
                              if (offeringAction.dependencies && Array.isArray(offeringAction.dependencies) && offeringAction.dependencies.length > 0) {
                                offeringAction.dependencies = offeringAction.dependencies.filter((x: WsSalesSolutionDependency) => x.id !== listItem.id);
                              }

                            } else if (title === 'Assumptions') {
                              if (offeringAction.assumptions && Array.isArray(offeringAction.assumptions) && offeringAction.assumptions.length > 0) {
                                offeringAction.assumptions = offeringAction.assumptions.filter((x: WsSalesSolutionAssumption) => x.id !== listItem.id);
                              }

                            } else if (title === 'Deliverables') {
                              if (offeringAction.children && Array.isArray(offeringAction.children) && offeringAction.children.length > 0) {
                                offeringAction.children = offeringAction.children.filter((x) => !(x.id === listItem.id && x instanceof WsSalesSolutionDeliverableClass));
                              }

                            } else if (title === 'Work Products') {
                              if (offeringAction.children && Array.isArray(offeringAction.children) && offeringAction.children.length > 0) {
                                offeringAction.children = offeringAction.children.filter((x) => !(x.id === listItem.id && x instanceof WsSalesSolutionWorkProductClass));
                              }

                            } else if (title === 'Roles') {
                              if (offeringAction.children && Array.isArray(offeringAction.children) && offeringAction.children.length > 0) {
                                offeringAction.children = offeringAction.children.filter((x, xindex: number) => {
                                  return !(x.id === listItem.id && listIndex === xindex && x instanceof WsSalesSolutionOfferingRoleClass);
                                });
                              }

                            } else if (title === 'Tools') {
                              if (offeringAction.children && Array.isArray(offeringAction.children) && offeringAction.children.length > 0) {
                                offeringAction.children = offeringAction.children.filter((x) => !(x.id === listItem.id && x instanceof WsSalesSolutionToolClass));
                              }

                            } else if (title === 'Risks') {
                              if (offeringAction.children && Array.isArray(offeringAction.children) && offeringAction.children.length > 0) {
                                offeringAction.children = offeringAction.children.filter((x) => !(x.id === listItem.id && x instanceof WsSalesSolutionRiskClass));
                              }
                            }

                            setItems(nextItems);
                          }
                        } />
                      </div>
                    </>

                    :

                    // show

                    <>
                      {
                        title === 'Roles'
                        ?
                          <>
                            <div className="ws-sales-solution-admin-metrics-item-field" style={{ fontSize: '12px', flexGrow: 1 }}>
                              {listItem.name}
                              {
                                itemIsCapability(offeringAction)
                                &&
                                roles
                                &&
                                <WsPersonRoleDetails personRole={listItem} staticRoles={roles} />
                              }
                            </div>
                            <div className="ws-sales-solution-admin-metrics-item-field" style={{ fontSize: '12px', marginLeft: '10px' }}>
                              {/* {listItem.value}% */}
                            </div>
                          </>
                        :
                          <div className="ws-sales-solution-admin-metrics-item-field" style={{ fontSize: '12px' }}>
                            {
                              (title === 'Deliverables' || title === 'Work Products')
                              ?
                              <>
                                {
                                  avanade
                                  &&
                                  listItem.documentId
                                  ?
                                  <a
                                    onClick={async (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                                      event.preventDefault(); // TODO: is this required?

                                      const documentDownloadResult = await getDocumentDownload(listItem.documentId);

                                      if (documentDownloadResult && documentDownloadResult.sasUrl) {
                                        FileSaver.saveAs(documentDownloadResult.sasUrl, documentDownloadResult.documentFileName);
                                      } else {
                                        alert('Document does not exist in storage!'); // TODO: use dialog
                                      }
                                    }}
                                  ><Icon iconName='Download' style={{ fontSize: '14px', verticalAlign: 'top', marginTop: '-2px' }} /> {listItem.name} ({listItem.format.name})</a>
                                  :
                                  <>{listItem.name}</>
                                }
                              </>
                              :
                              <>
                                <WsSalesSolutionItemPath
                                  items={items}
                                  itemType={getItemTypeByTitle(title)}
                                  item={listItem}
                                />
                                {listItem.name}
                              </>
                            }
                          </div>
                      }
                    </>
                  }
                </div>
              );

            } else {
              return null;
            }
          })
          :
          'None'
        }



        {/* add button */}

        {
          mode === 'edit'
          &&
          <>
            <div className="ws-sales-solution-metric-add" style={{ marginTop: '5px' }}
              onClick={() => {

                if (title === 'Roles' && roles) {

                  const nextItems = [ ...items ];

                  const x = roles[0].clone();

                  if (offeringAction.children) {
                    offeringAction.children.push(x);
                  } else {
                    offeringAction.children = [ x ];
                  }

                  setItems(nextItems);

                } else {
                  // new item
                  setEditItem(undefined);
                  setEditItemId('');
                }
              }}
            >
              <Icon iconName={'CircleAdditionSolid'} style={{ fontSize: '17px', verticalAlign: 'middle', marginTop: '-2px' }}/> {getAddNewItemLabel(title)}
            </div>

            {
              (
                editItemId === '' // new item
                ||
                editItemId       // edit item
              )
              &&
              <WsSalesSolutionAddDialog
                title={title}
                editItem={editItem}
                setEditItem={setEditItem}
                editItemId={editItemId}
                setEditItemId={setEditItemId}
                items={items}
                setItems={setItems}
                offeringAction={offeringAction}
              />
            }
          </>
        }

      </div>
    );

  } else {
    return (
      <Loading />
    );
  }
};


type WsSalesSolutionCapabilitySizeDescriptionEditProps = {
  size: string;
  item: any;
  items: WsSalesSolutionItem[];
  setItems: (value: React.SetStateAction<WsSalesSolutionItem[]>) => void;
};

const WsSalesSolutionCapabilitySizeDescriptionEdit = (props: WsSalesSolutionCapabilitySizeDescriptionEditProps) => {

  return (
    <div>
      <TextField
        multiline={true}
        rows={4}
        onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined): void => {
          const newItems = [ ...props.items ];

          if (newValue) {
            props.item.sizeDescription[props.size] = newValue;
          } else {
            props.item.sizeDescription[props.size] = '';
          }

          props.setItems(newItems);
        }}
        value={ props.item.sizeDescription[props.size] }
      />
    </div>
  );
};


const getItemSizeDescription = (sizeDescription: any) => {

  return (
    <>
    <b>Small (S)</b> - {sizeDescription.S}<br />
    <br />
    <b>Medium (M)</b> - {sizeDescription.M}<br />
    <br />
    <b>Complex (C)</b> - {sizeDescription.C}<br />
    <br />
    <b>Very Complex (VC)</b> - {sizeDescription.VC}<br />
    </>
  );
};




type WsSalesSolutionTeamTableProps = {
  title: string;
  items: WsSalesSolutionItem[];
  team: string;
  startDate: Date;
  staticRoles: WsSalesSolutionOfferingRoleClass[];
};

const WsSalesSolutionTeamTable = (props: WsSalesSolutionTeamTableProps) => {

  // const listArray: any[] = getUniqueRoles(getChildItemsFromTopLevelItems(props.items, 'roles', { includeChildCapabilities: true, includeChildActions: true, filterSelectedCapabilities: true, filterSelectedActions: true }));

  const listArray = getRolesFromItems(props.items);

  const list = listArray.filter((listItemAndActionItem) => {

    const listItem = listItemAndActionItem[0];

    const staticRole = props.staticRoles.find((sr) => sr.id === listItem.staticId);

    if (props.team) {
      return staticRole && staticRole.team === props.team;
    } else {
      return true;
    }
  });

  const onshore = list.filter((listItemAndActionItem) => {
    const listItem = listItemAndActionItem[0];

    const staticRole = props.staticRoles.find((sr) => sr.id === listItem.staticId);

    return staticRole && staticRole.location.startsWith('ONSHORE_');
  });

  const offshore = list.filter((listItemAndActionItem) => {
    const listItem = listItemAndActionItem[0];

    const staticRole = props.staticRoles.find((sr) => sr.id === listItem.staticId);
    
    return staticRole && staticRole.location.startsWith('OFFSHORE_');
  });

  const total = onshore.length + offshore.length;

  let onshorePercent  = 0;
  let offshorePercent = 0;

  if (total > 0) {
    onshorePercent = Number((onshore.length / total * 100).toFixed(1));
    offshorePercent = 100 - onshorePercent;
  }

  return (
    <div className="ws-sales-solution-team-table">
      <table className="table is-fullwidth is-size-6">
        <tbody>
          <tr>
            <td style={{ fontSize: '14px' }}><b>{props.title} Size</b></td>
            <td><b>{list.length}</b></td>
          </tr>
          <tr>
            <td style={{ fontSize: '14px' }}>Onshore</td>
            <td>{onshore.length}</td>
          </tr>
          <tr>
            <td style={{ fontSize: '14px' }}>Offshore</td>
            <td>{offshore.length}</td>
          </tr>
          <tr>
            <td style={{ fontSize: '14px' }}>Onshore/Offshore Ratio</td>
            <td>{parseFloat(onshorePercent.toFixed(2))}/{parseFloat(offshorePercent.toFixed(2))}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};




const getRolesFromItems = (items: WsSalesSolutionItem[]) => {

  let list: [ WsPersonRole, WsSalesSolutionItem | WsSalesSolutionAction, string ][] = [];

  items.forEach((item) => {

    const timelineRoles = getTimelineRoles(item, moment.tz('2024-04-01', 'UTC').toDate(), { includeChildCapabilities: true, items });

    const personRoles = getPersonRoles(timelineRoles);

    const personRolesList = personRoles.map((personRole) => {

      let listItem: [ WsPersonRole, WsSalesSolutionItem | WsSalesSolutionAction, string,  ] = [
        personRole,
        item,
        ''
      ];

      return listItem;
    });

    list.push(...personRolesList);
  });



  return list;
};



type WsSalesSolutionTeamPyramidProps = {
  title: string;
  items: WsSalesSolutionItem[];
  team: string;
  location: string;
  startDate: Date;
  staticRoles: WsSalesSolutionOfferingRoleClass[];
};

const WsSalesSolutionTeamPyramid = (props: WsSalesSolutionTeamPyramidProps) => {

  const [ width, setWidth ] = useState<{ [ key: string ]: number }>({});

  // const listArray: any[] = getUniqueRoles(getChildItemsFromTopLevelItems(props.items, 'roles', { includeChildCapabilities: true, includeChildActions: true, filterSelectedCapabilities: true, filterSelectedActions: true }));

  const listArray = getRolesFromItems(props.items);



  const listFiltered = listArray.filter((listItemAndActionItem) => {

    const listItem = listItemAndActionItem[0];

    const staticRole = props.staticRoles.find((sr) => sr.id === listItem.staticId);

    if (props.team) {
      if (props.location) {

        return staticRole && staticRole.team === props.team && staticRole.location === props.location;

      } else {
        return staticRole && staticRole.team === props.team;
      }

    } else {
      return true;
    }
  });



  const list: { role: any, count: number }[] = [];

  listFiltered.forEach((listItemAndActionItem) => {
    const listItem = listItemAndActionItem[0];

    const iFind = list.find((i) => i.role.name === listItem.name); // TODO: use roleType instead
    if (iFind) {
      iFind.count = iFind.count + 1;
    } else {
      list.push({ role: listItem, count: 1 });
    }
  });



  const listSorted = list.sort((a: any, b: any) => {
    if (a.count < b.count) {
      return -1;
    } else if (a.count > b.count) {
      return 1;
    } else {
      if (a.role.name < b.role.name) return -1;
      if (a.role.name > b.role.name) return 1;
      return 0;
    }
  });

  let cssBackgroundColor = '#808080';

  if (props.team === 'AVANADE') {
    cssBackgroundColor = '#FF5800';
  } else if (props.team === 'ACCENTURE') {
    cssBackgroundColor = '#A100FF';
  }



  useEffect(() => {
    setTimeout(() => {
      const w: { [ key: string ]: number } = {};

      const maxCount = Math.max(...list.map(i => i.count));

      listSorted.forEach((listItem) => {
        const r = listItem.count / maxCount;
        const p = r * 100;

        w[listItem.role.id] = p;

      });

      setWidth(w);
    }, 150);
  }, []);



  console.log(listSorted);

  // list

  const itemList = listSorted.map((listItem) => {

    return (
      <tr key={`ws-sales-solution-team-pyramid-list-item-${listItem.role.id}`}>
        <td>{listItem.role.name}</td>
        <td>
          <div
            className="ws-sales-solution-team-pyramid-bar"
            style={{
              width: `${width[listItem.role.id] ? width[listItem.role.id] : 10}%`,
              backgroundColor: cssBackgroundColor
            }}
          >{listItem.count}</div>
        </td>
      </tr>
    );
  });


  // return

  return (
    <div className="ws-sales-solution-team-pyramid">
      <div className="ws-sales-solution-team-pyramid-title">
        {props.title}
      </div>
      <table className="is-size-7">
        <tbody>
          {itemList}
        </tbody>
      </table>
    </div>
  );
};




const WsSalesSolutionItemPath = (props: { items: WsSalesSolutionItem[], itemType: string, item: any }) => {

  return (
    <TooltipHost
      content={
        <div style={{ fontSize: '13px' }}>
          {getItemPath(props.items, props.itemType, props.item)}
        </div>
      }
      id={`ws-sales-solution-metric-path-tooltip-${props.item.id}`}
      directionalHint={DirectionalHint.topCenter}
      calloutProps={{
        // className: 'ws-sales-solution-metric-path-tooltip-callout',
        style: {
          // width: '100px'
        },
        gapSpace: 10,
        beakWidth: 18
      }}
    >
      <Icon
        className="ws-sales-solution-item-path-tooltip-icon"
        iconName="BranchMerge"
        style={{
          fontSize: '17px',
          verticalAlign: 'top',
          marginRight: '5px',
          marginTop: '0px',
          marginLeft: props.itemType === 'metrics' ? '-24px' : '0px'
        }}
        aria-describedby={`ws-sales-solution-metric-path-tooltip-${props.item.id}`}
      />
    </TooltipHost>
  )
};




export {
  WsSalesSolutionCoreMetricsList,
  WsSalesSolutionRoleTypesList,
  WsSalesSolutionComplexity,
  WsSalesSolutionLinks,
  WsSalesSolutionDependenciesAndAssumptions,
  WsSalesSolutionCapabilitySizeDescriptionEdit,
  getItemSizeDescription,
  WsSalesSolutionTeamTable,
  WsSalesSolutionTeamPyramid,
  getChildItemsFromTopLevelItems,
  getDocumentDownload,
  WsSalesSolutionItemPath
};
